// extracted by mini-css-extract-plugin
module.exports = {"baseModal":"antd-pro-ui-async-modal-index-baseModal","autoFitHeight":"antd-pro-ui-async-modal-index-autoFitHeight"};